/* RESPONSIBLE TEAM: team-automation-foundations */
import { EntityType } from 'embercom/models/data/entity-types';

export interface AudienceSummaryItem {
  label: string;
  value: string | undefined;
  routeName: string;
}

export interface AudienceItemCounts {
  total: number;
  [EntityType.Guideline]?: number;
  [EntityType.EscalationRule]?: number;
  [EntityType.Article]?: number;
  [EntityType.ContentSnippet]?: number;
  [EntityType.ArticleContent]?: number;
  [EntityType.FileSourceContent]?: number;
  [EntityType.ExternalContent]?: number;
  [EntityType.InternalArticle]?: number;
  [EntityType.WorkflowConnectorAction]?: number;
  [EntityType.CustomBotSnapshot]?: number;
  [EntityType.AIAgentWorkflow]?: number;
}

export const ContentEntityTypes = [
  EntityType.ContentSnippet,
  EntityType.ArticleContent,
  EntityType.FileSourceContent,
  EntityType.ExternalContent,
  EntityType.InternalArticle,
] as const;

export type AudienceItems = {
  [key: number]: AudienceItemCounts;
} & {
  everybody: AudienceItemCounts;
};

export interface BrandIdentityData {
  brand: { name: string };
  identity: {
    avatar: AvatarData;
    name: string;
  };
}

export type BrandsFromRulesets = {
  [key: string]: BrandIdentityData;
  default: BrandIdentityData;
};

export interface EverybodySegment {
  id: 'everybody';
  name: string;
  nameWithFallback: string;
  rulesetId: 'everybody';
  predicateGroup: { predicates: [] };
}

export interface AvatarImageUrls {
  square_25: string;
  square_50: string;
  square_128: string;
}

export interface AvatarData {
  initials: string;
  color: string;
  image_urls: AvatarImageUrls;
  image_url: string;
  image_dark_urls: AvatarImageUrls;
  image_dark_url: string;
  shape: string;
  label: string;
}
